/* eslint-disable @typescript-eslint/no-unused-vars */

import { inject, Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, Observable, of } from 'rxjs';
import { ConfigurationActions, TokenUpdated, UpdateSiteInformation, UsernameUpdated, } from './config.actions';
import { IPayloadAction } from '../scanner/scanner.actions';
import { getLocalStorageItem, setLocalStorageItem } from '@drc-eca/eca-lrc-common-ui';
import { AppContextService, EcaSecurityService } from '@drc-eca/eca-components-lib';
import { filter, pluck, switchMap, withLatestFrom } from 'rxjs/operators';


@Injectable()
export class ConfigEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<any>>(Store);
  private ecaSecurityService = inject(EcaSecurityService);
  private appContextService = inject(AppContextService);


  updateToken$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(ConfigurationActions.UPDATE_TOKEN),
    switchMap((action: IPayloadAction) => {
      return combineLatest([
        this.appContextService.getToken(),
        this.ecaSecurityService.getUser()
      ]);
    }),
    switchMap(([token, user]) => {
      return of(
        new TokenUpdated(token),
        new UsernameUpdated(user.username),
      );
    })
  ));

  UpdateSiteInformation$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(ConfigurationActions.UPDATE_SITE_INFORMATION),
    withLatestFrom(
      this.store$.select('user')
        .pipe(
          filter(Boolean),
          pluck('username')
        )
    ),
    switchMap(([action, username]) => {
      setLocalStorageItem(`${username}:localScanning:siteInformation`, JSON.stringify(action['payload']));
      return of({type: 'NO_ACTION'});
    }),
  ));

  usernameUpdated$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(ConfigurationActions.USERNAME_UPDATED),
    withLatestFrom(
      this.store$.select('user')
        .pipe(
          filter(Boolean),
          pluck('username')
        )
    ),
    switchMap(([action, username]) => {
      const siteInformation = getLocalStorageItem(`${username}:localScanning:siteInformation`);
      if (siteInformation) {
        return of(new UpdateSiteInformation(JSON.parse(siteInformation)));
      }
      return of({type: 'NO_PREVIOUSLY_SELECTED_SITE'});

    }),
  ));
}
